// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-7dd57f10]:export {\n  primaryColor: #003586;\n  menuText: white;\n  menuActiveText: #1596d2;\n  subMenuActiveText: white;\n  menuBg: #1a2739;\n  menuHover: rgba(73, 85, 105, 0.4);\n  subMenuBg: #001429;\n  subMenuHover: #198fff;\n  sideBarWidth: 240px;\n  linkColor: #037aff;\n}\n.expired-table[data-v-7dd57f10] .el-table .row-warning {\n  background-color: #fcd260;\n}\n.expired-table[data-v-7dd57f10] .el-table .row-danger {\n  background-color: #ffa2a0;\n}\n", ""]);
// Exports
module.exports = exports;
